import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=e203f454"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e203f454')) {
      api.createRecord('e203f454', component.options)
    } else {
      api.reload('e203f454', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=e203f454", function () {
      api.rerender('e203f454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/dashboard/Dashboard.vue"
export default component.exports